import { waitForData, getBundleFns } from "../tool"
import { transUserPri } from "@/utils/project"

const state = {
  socketStatus: "Unconnected",
  ossClient: {
    status: "Null", // ["Null", "Pending", "Finished"]
    data: null,
    lastReqTime: 0,
    expires: 60 * 30 // 30分钟过期
  },
  projectPermission: {
    status: "Null", // ["Null", "Pending", "Finished"]
    data: null,
    lastReqTime: 0,
    expires: 60 * 30 // 30分钟过期
  }
}

const mutations = {
  SET_SOCKET_STATUS: (state, socketStatus) => {
    state.socketStatus = socketStatus
  },
  SET_OSS_Client: (state, dataObj) => {
    Object.assign(state.ossClient, dataObj)
  },
  SET_Project_Permission: (state, dataObj) => {
    Object.assign(state.projectPermission, dataObj)
  }
}

const actions = {
  // 之后用websocket弄
  changeSocketStatus({ commit }, status) {
    commit("SET_SOCKET_STATUS", status)
  },
  initOssClient({ commit, state }) {
    let bundleFnObj = getBundleFns({ commit, mutation: "SET_OSS_Client" })
    return waitForData(state.ossClient, bundleFnObj)
  },
  cleanProjectPermission({ commit }) {
    commit("SET_Project_Permission", { status: "Null", data: null })
  },
  getProjectPermission({ commit, state }) {
    let bundleFnObj = getBundleFns({ commit, mutation: "SET_Project_Permission" })
    return waitForData(state.projectPermission, bundleFnObj)
      .then(data => {
        for (let projectId in data) {
          data[projectId].rolePris = transUserPri(
            data[projectId].privileges,
            data[projectId].isAdmin
          )
        }
        commit("SET_Project_Permission", { data })
        return data
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
